export default {
  settings: {
    label: 'Настройки',
    language: {
      label: 'Язык',
    },
  },
}
